import { Button, Modal, ModalDialog, FormControl, FormLabel, Input, Stack, IconButton } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { postFetch } from "../../../../../../fetch/fetch";
import { dateToDateString } from "../../../etc/etcfunctions";
import { Delete } from "@mui/icons-material";

const IncentiveModal: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([
        { field: "date", headerName: "날짜", width: 100 },
        { field: "description", headerName: "내용", width: 250 },
        { field: "amount", headerName: "금액", width: 100 },
        { field: "author", headerName: "작성자", width: 100 },
        { field: "createdAt", headerName: "작성일", width: 150 },
        { field: "systemNote", headerName: "시스템 부여", width: 220 },
        {
            field: "delete", headerName: "삭제", width: 100, renderCell: (params: any) => {

                const id = params.row.id;

                const deleteIncentive = async () => {
                    try{
                        if(!id){
                            return;
                        }

                        if(params.row.systemNote){
                            alert("시스템 부여된 인센티브는 해당 관리 페이지에서 삭제할 수 있습니다.");
                            return;
                        }

                        if(!window.confirm("정말로 인센티브를 삭제하시겠습니까?")){
                            return;
                        }

                        const result : any = await postFetch("/dashboard/salary/deleteincentive", {
                            incentiveId : id,
                        });

                        if(result.message === "success"){
                            props.notify("success", "인센티브가 성공적으로 삭제되었습니다.");
                            props.setIncentiveUpdate(Math.random());
                        }

                    }catch(e){
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton
                        onClick={deleteIncentive}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false);

    // 인센티브 추가 모달의 입력값 상태
    const [newIncentive, setNewIncentive] = useState({
        date: "",
        description: "",
        amount: "",
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {

        setNewIncentive({
            date: "",
            description: "",
            amount: "",
        });

    }, [props.open, modalOpen]);

    useEffect(() => {

        if (!props.incentiveData) {
            setRows([]);
            return;
        }

        const newRows: any = [];

        props.incentiveData.forEach((item: any) => {
            const oneRow: any = {};
            oneRow.id = item.id;
            oneRow.date = dateToDateString(new Date(item.targetDate));
            oneRow.description = item.description;
            oneRow.amount = item.amount.toLocaleString() + "원";
            oneRow.author = item.authorName;
            oneRow.createdAt = dateToDateString(new Date(item.createdAt));
            oneRow.systemNote = item.systemNote || '';
            newRows.push(oneRow);
        })

        setRows([...newRows]);

    }, [props.incentiveData]);

    const handleChange = (field: "date" | "description" | "amount", value: string) => {
        setNewIncentive((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const submitNewIncentive = async (e: React.FormEvent) => {
        e.preventDefault();

        try {

            if (!props.user) {
                return;
            }

            if (!newIncentive.date || !newIncentive.description || !newIncentive.amount) {
                return;
            }

            setLoading(true);

            const targetDate = new Date(newIncentive.date).getTime();

            const result: any = await postFetch("/dashboard/salary/addincentive", {
                userId: props.user.id,
                date: targetDate,
                description: newIncentive.description,
                amount: Number(newIncentive.amount),
            });

            // API 결과에 따라 rows에 추가 (id는 임시로 Date.now() 사용)
            setRows((prev) => [
                ...prev,
                {
                    id: result?.id || Date.now(),
                    date: newIncentive.date,
                    description: newIncentive.description,
                    amount: Number(newIncentive.amount),
                    author: props.user?.name || "",
                    createdAt: new Date().toISOString().slice(0, 10), // YYYY-MM-DD
                },
            ]);

            // 입력값 초기화 & 모달 닫기
            setNewIncentive({
                date: "",
                description: "",
                amount: "",
            });
            setModalOpen(false);
            setLoading(false);
            props.setIncentiveUpdate(Math.random());
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    return (
        <div>
            {/* 메인 인센티브 관리 모달 */}
            <Modal
                open={props.open}
                onClose={props.onClose}
            >
                <ModalDialog>
                    <div
                        style={{
                            fontSize: "18px",
                            fontWeight: 600,
                            marginBottom: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            {props.selectedDate ? props.selectedDate.getMonth() + 1 + "월" : ""} 인센티브 관리
                        </div>
                        <div>
                            <Button
                                variant="outlined"
                                onClick={() => setModalOpen(true)}
                            >
                                인센티브 추가
                            </Button>
                        </div>
                    </div>
                    <div
                        style={{
                            width: "800px",
                            height: "400px",
                        }}
                    >
                        <DataGridPremium
                            rows={rows}
                            columns={columns}
                            density="compact"
                        />
                    </div>
                </ModalDialog>
            </Modal>

            {/* 인센티브 추가 모달 */}
            <Modal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            >
                <ModalDialog>
                    <form onSubmit={submitNewIncentive}>
                        <Stack spacing={2}>
                            <div style={{ fontSize: "18px", fontWeight: 600 }}>
                                인센티브 추가하기
                            </div>

                            <FormControl>
                                <FormLabel>날짜</FormLabel>
                                <Input
                                    type="date"
                                    value={newIncentive.date}
                                    onChange={(e) =>
                                        handleChange("date", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>내용</FormLabel>
                                <Input
                                    placeholder="내용을 입력하세요"
                                    value={newIncentive.description}
                                    onChange={(e) =>
                                        handleChange("description", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>금액</FormLabel>
                                <Input
                                    type="number"
                                    placeholder="금액을 입력하세요"
                                    value={newIncentive.amount}
                                    onChange={(e) =>
                                        handleChange("amount", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    type="button"
                                    onClick={() => setModalOpen(false)}
                                >
                                    취소
                                </Button>
                                <Button type="submit"
                                    loading={loading}
                                    disabled={
                                        loading
                                        || !newIncentive.date
                                        || !newIncentive.description
                                        || !newIncentive.amount
                                    }
                                >
                                    전송
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
        </div>
    );
};

export default IncentiveModal;